var exports = {
  "kL": "xcc377c0b--9d2911--container",
  "DD": "xcc377c0b--9d2911--title",
  "V0": "xcc377c0b--9d2911--sections",
  "p_": "xcc377c0b--9d2911--list",
  "AS": "xcc377c0b--9d2911--item",
  "Yq": "xcc377c0b--9d2911--reviews",
  "qr": "xcc377c0b--9d2911--footer",
};

module.exports = exports;
